import React from "react";
import { Link } from "react-router-dom";
import "./about.css";

const About = () => {
  return (
    <section className="about" id="about">
      <div className="about__container">
        <div className="about__typography">
          <span>about me</span>
          <span>about me</span>
          <span>about me</span>
        </div>
        <div className="about__text">
          <span>
            Hello! I am Muhammad Agung Permana, I am passionate about
            <span className="about__outline">
              {" "}
              developing Website
            </span>{" "}
            both <span className="about__outline"> user interface</span>.
          </span>
        </div>
      </div>
    </section>
  );
};

export default About;
